<template>
    <div>
        <div class="skill">
            <div class="outer">
                <div class="inner">
                    <div class="number">{{currentValue}}</div>
                </div>
            </div>

            <svg >
                <circle 
                cx="50%" 
                cy="50%" 
                :style="`
                stroke-dasharray: 515;
                stroke-dashoffset: ${512*Math.abs(percentageValue-1)};
                `"  
                stroke-linecap="rounded" />
            </svg>
            <b-img
            :src="require('@/assets/icons/icon-simple-star.svg')"
            class="icon-simple-star pb-2"
            ></b-img>
        </div>
    </div>
</template>

<script>

export default ({
    props:{
        currentValue:{
            type:Number,
            default:0
        },
        percentageValue:{
            type:Number,
            default:0
        },
    },
    data() {
    return {

    }  
    },
})
</script>


<style scoped lang="scss">
$circleWidth: 180px;//150px;
$barWidth: 15px;
.icon-simple-star{
    position: absolute;
    
}
.skill{
    width: $circleWidth;
    height: $circleWidth;
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;
    .outer{
        height: 100%;
        width: 100%;
        border-radius: 50%;
        // border: 1px solid red;
        background-color: #E4E4E4;

        display: flex;
        justify-content: center;
        align-items: center;
        .inner{
            height: #{'calc(100% - #{$barWidth*2} + 3px)'};
            width: #{'calc(100% - #{$barWidth*2} + 3px)'};
            border-radius: 50%;
            // border: 1px solid red;
            background-color: #ffffff;

            display: flex;
            justify-content: center;
            align-items: center;

            .number{
                z-index: 100;
                color: #ffffff;
                font-size: 60px;
            }
        }
    }

    svg{
        width: 100%;
        height: 100%;
        position: absolute;
        transform: rotate(-90deg);
        overflow: visible;
        circle{
            fill: none;
            stroke: #FFC700;
            stroke-width: $barWidth;
            r:#{'calc((#{$circleWidth/2}) - #{$barWidth/2})'};
            stroke-linecap: round;
            // stroke-dasharray: 515;
            // stroke-dashoffset: 512;
            filter: drop-shadow(0 0 0.2rem rgba(0, 0, 0, 0.283));
        }
    }
}
</style>